<template>
    <CContainer fluid>
        <h3>Formulario de Prospecto</h3>
        <CCard class="mt-4">
            <CCardBody class="p-4">
                <CForm>
                    <CCol sm="4" class="d-inline-block">
                        <CSelect
                            label="Tipo de Identificación: "
                            addLabelClasses="text-muted font-weight-bold text-capitalize"
                            :value.sync="directory.idType"
                            :options="[
                                { value: '', label: 'Seleccionar' },
                                ...idTypes.map(type => {
                                    return {
                                        value: type.id_Tipo_Identificacion,
                                        label: type.identificacion
                                    }
                                })
                            ]"
                            :isValid="directory.idType.length > 0"
                            @change="() => {
                                clearNames()
                                const foundType = idTypes.find(idType => directory.idType === idType.id_Tipo_Identificacion)
      
                                enableNameLastname = foundType ? foundType.activar_Nombre_Apellido === 'V' : false
                                validate()
                            }"                        />
                    </CCol>
                    <CCol sm="4" class="d-inline-block">
                        <CInput
                            label="Identificación: "
                            addLabelClasses="text-muted font-weight-bold text-capitalize"
                            :value.sync="directory.id"
                            :isValid="isIdValid"
                            @input="() => {                                
                                idValidator()
                            }"
                            @blur="() => {
                                directory.digit = directory.personType == 1 ? calcularDv(directory.id) : 0
                                validate()
                            }"
                        />
                    </CCol>
                    <CCol sm="1" class="d-inline-block" v-if="directory.personType == 1">
                        <CInput                            
                            :value="directory.digit"
                            disabled="true"
                        />
                    </CCol>
                    <CCol sm="12" class="d-inline-block" v-if="!enableNameLastname">
                        <CInput
                            label="Empresa: "
                            addLabelClasses="text-muted font-weight-bold text-capitalize"
                            :value.sync="directory.companyName"
                            :isValid="directory.companyName.length > 0"
                            @blur="() => {
                                validate()                                
                            }"
                        />
                    </CCol>
                    <CCol sm="6" class="d-inline-block" v-if="enableNameLastname">
                        <CInput
                            label="Nombre 1: "
                            addLabelClasses="text-muted font-weight-bold text-capitalize"
                            :value.sync="directory.name1"
                            :isValid="directory.name1.length > 0"
                            @blur="() => {
                                validate()
                            }"
                        />
                    </CCol>
                    <CCol sm="6" class="d-inline-block" v-if="enableNameLastname">
                        <CInput
                            label="Nombre 2: "
                            addLabelClasses="text-muted font-weight-bold text-capitalize"
                            :value.sync="directory.name2"
                        />
                    </CCol>
                    <CCol sm="6" class="d-inline-block" v-if="enableNameLastname">
                        <CInput
                            label="Apellido 1: "
                            addLabelClasses="text-muted font-weight-bold text-capitalize"
                            :value.sync="directory.lastName1"
                            :isValid="directory.lastName1.length > 0"
                            @blur="validate()"
                        />
                    </CCol>
                    <CCol sm="6" class="d-inline-block" v-if="enableNameLastname">
                        <CInput
                            label="Apellido 2: "
                            addLabelClasses="text-muted font-weight-bold text-capitalize"
                            :value.sync="directory.lastName2"
                        />
                    </CCol>
                    <CCol sm="12" class="d-inline-block">
                        <CInput
                            label="Dirección: "
                            addLabelClasses="text-muted font-weight-bold text-capitalize"
                            :value.sync="directory.address"
                            :isValid="directory.address.length > 0"
                        />
                    </CCol>
                    <CCol sm="12" class="d-inline-block">
                        <CInput                            
                            :value.sync="directory.auxAddress"
                        />
                    </CCol>
                    <CCol sm="6" class="d-inline-block">
                        <CAutocomplete
                          required
                          label="Ciudad: "
                          :value="directory.city"
                          :options="cities.map(city => {
                            return {
                              value: city.id_Ciudad,
                              label: `${city.ciudad} - ${city.departamento}`
                            }
                          })"
                          @update:input="(nvalue) => {
                            directory.city = nvalue;
                            directory.neighborhood = '';
                            neighborhoods = [];
                            getNeighborhoods(nvalue);
                          }">
                        </CAutocomplete>
                    </CCol>
                    <CCol sm="6" class="d-inline-block">
                        <CSelect
                            :options="[
                            { value: '', label: 'Seleccionar' },
                            ...neighborhoods.map(neighborhood => {
                                return {
                                    value: neighborhood.id_Barrio,
                                    label: neighborhood.nombre_Barrio + ' - ' + neighborhood.localidad
                                }
                            })]"                            
                            label="Barrio: "
                            :value="directory.neighborhood"
                            @update:input="nvalue => {
                                directory.neighborhood = nvalue
                            }"/>
                    </CCol>
                    <CCol sm="6" class="d-inline-block">
                        <CSelect
                            :options="[
                            { value: '', label: 'Seleccionar' },
                            ...zones.map(zone => {
                                return {
                                    value: zone.id_Zona,
                                    label: zone.nombre_Zona
                                }
                            })]"
                            
                            label="Zona: "
                            :value.sync="directory.zone"/>
                        
                    </CCol>
                    <CCol sm="4" class="d-inline-block">
                        <CInput
                            label="Código Postal: "
                            addLabelClasses="text-muted font-weight-bold text-capitalize"
                            :value="directory.zipCode"
                            @input="value => {
                                directory.zipCode = value
                                
                            }"
                        />
                    </CCol>
                    <CCol sm="12" class="d-inline-block">
                        <CInput
                            label="Observaciones: "
                            addLabelClasses="text-muted font-weight-bold text-capitalize"
                            :value.sync="directory.comments"
                        />
                    </CCol>
                    <CCol sm="4" class="d-inline-block">
                        <CSelect
                            label="Tipo Persona: "
                            addLabelClasses="text-muted font-weight-bold text-capitalize"
                            :value.sync="directory.personType"
                            :options="[
                                { value: '1', label: 'Persona Jurídica'},
                                { value: '2', label: 'Persona Natural'}
                            ]"
                        />
                    </CCol>
                    <CCol sm="6" class="d-inline-block">
                        <CSelect
                            label="Responsabilidad Fiscal: "
                            addLabelClasses="text-muted font-weight-bold text-capitalize"
                            :value.sync="directory.fiscalDuty"
                            :options="[
                                { value: '', label: 'Seleccionar' },
                                ...fiscalDuties.map(duty => {
                                    return {
                                        value: duty.id_TipoResponsabilidaFiscal,
                                        label: `${duty.codigo} - ${duty.descripcion}`
                                    }
                                })
                            ]"/>
                    </CCol>
                    <CCol sm="6" class="d-inline-block">
                        <CSelect
                            label="Tipo Industria: "
                            addLabelClasses="text-muted font-weight-bold text-capitalize"
                            :value.sync="directory.industryType"
                            :options="[
                                { value: '', label: 'Seleccionar' },
                                ...industryTypes.map(type => {
                                    return {
                                        value: type.id_TipoIndustria,
                                        label: `${type.codigo} - ${type.industria}`
                                    }
                                })
                            ]"/>
                    </CCol>
                    <CCol sm="6" class="d-inline-block">
                        <CSelect
                            label="Tipo Clasificación Cliente: "
                            addLabelClasses="text-muted font-weight-bold text-capitalize"
                            :value.sync="directory.customerClassType"
                            :options="[
                                { value: '', label: 'Seleccionar' },
                                ...customerClassTypes.map(type => {
                                    return {
                                        value: type.id_TipoClasificacionCliente,
                                        label: type.tipo_ClasificacionCliente
                                    }
                                })
                            ]"/>
                    </CCol>
                </CForm>
            </CCardBody>
            <CCardFooter align="center">
                <CButton
                  color="primary"
                  square 
                  class="mr-2 d-inline-block"
                  @click="save()"
                  :class="isValidForm?'':'disabled'"
                  :disabled="!isValidForm">
                  <CIcon name="cil-check-alt"/>
                  <span class="align-middle mr-2">Guardar</span>
                </CButton>
                <CButton
                  color="secondary"
                  square 
                  class="mr-2 d-inline-block"
                  :to="rootPath">
                  <CIcon name="cil-x"/>
                  <span class="align-middle mr-2">Cancelar</span>
                </CButton>
            </CCardFooter>
        </CCard>
        
        <CElementCover v-show="loading" />
    </CContainer>
</template>
<script>
  import constants from "@/constants";
  import { calcularDv } from "@/digitoverifica";
  import { 
    dataListCiudades,
    dataListBarrios,
    dataListZonas,
    dataListTiposIdenticacion,
    dataListTiposResponsabilidadFiscal,
    dataListTiposIndustrias,
    dataListTiposClasificacionClientes,
    crearDirectorioProspecto
  } from "@/api";

  import CAutocomplete from "../../containers/CAutocomplete.vue";

  export default {
    components: {
      CAutocomplete
    },
    data() {
      return {
        rootPath: "",
        isCreate: false,
        directory: {
          idType: '',
          id: '',
          digit: '',
          companyName: '',
          name1: '',
          name2: '',
          lastName1: '',
          lastName2: '',
          address: '',
          auxAddress: '',
          city: '',
          neighborhood: '',
          zone: '',
          zipCode: '',
          comments: '',
          personType: 1,
          fiscalDuty: '',
          servedBy: '',
          industryType: '',
          customerClassType: ''
        },
        cities: [],
        neighborhoods: [],
        zones: [],
        idTypes: [],
        fiscalDuties: [],
        industryTypes: [],
        customerClassTypes: [],
        loading: false,
        enableNameLastname: false,
        isIdValid: false
      }
    },
    mounted() {
      const splittedPath = this.$router.currentRoute.fullPath.split("/");
      const action = splittedPath[splittedPath.length - 1];

      this.rootPath = this.$router.currentRoute.fullPath.replace(`/${action}`, "");
      this.isCreate = action === "agregar";

      if (!this.isCreate) {
        if(this.type !== "PP") {
          this.$router.push({ path: this.rootPath });
        }
      }

      this.getCities()
      this.getZones()
      this.getIdTypes()
      this.getFiscalDuties()
      this.getIndustryTypes()
      this.getCustomerClassTypes()
    },
    methods: {
      calcularDv,
      async getCities(){
        try {
          const response = await dataListCiudades(this)
          this.cities = response
        } catch (error) {
          error  
        }
      },
      async getNeighborhoods(idCity){
        try {
          const response = await dataListBarrios(this, idCity)
          this.neighborhoods = response
        } catch (error) {
          error  
        }
      },
      async getZones(){
        try {
          const response = await dataListZonas(this)
          this.zones = response
        } catch (error) {
          error  
        }
      },
      async getIdTypes(){
        try {
          const response = await dataListTiposIdenticacion(this)
          this.idTypes = response
        } catch (error) {
          error   
        }
      },
      async getFiscalDuties(){
        try {
          const response = await dataListTiposResponsabilidadFiscal(this)
          this.fiscalDuties = response
        } catch (error) {
          error   
        }
      },
      async getIndustryTypes(){
        try {
          const response = await dataListTiposIndustrias(this)
          this.industryTypes = response
        } catch (error) {
          console.error(error);
        }
      },
      async getCustomerClassTypes(){
        try {
          const response = await dataListTiposClasificacionClientes(this)
          this.customerClassTypes = response
        } catch (error) {
          console.error(error);
        }
      },
      async createDirectory(){
        this.loading = true;

        try {
          // const response = await crearDirectorioProspecto(this, this.directory);
          await crearDirectorioProspecto(this, this.directory);
          
          this.$router.push({ path: this.rootPath });
        } catch (error) {
          this.$store.commit('setAlert', {
            color: "danger",
            message: `Error al crear el directorio. Error: ${error}`,
            show: 5
          })
        } finally{
          this.loading = false
        }
      },
      async updateDirectory(){
        try {
          this.loading = true
        } catch (error) {
          this.$store.commit('setAlert', {
            color: "danger",
            message: constants.messages.notDoneEdit,
            show: 5
          })
        } finally{
          this.loading = false
        }
      },
      save() {
        this.directory.servedBy = this.$store.state.user.data.id_Empleado
        this.isCreate ? this.createDirectory() : this.updateDirectory()
      },
      validate() {
        // const areValidNames = this.enableNameLastname ? this.areValidNames() : this.directory.companyName.length > 0
        // this.isValidForm = this.directory.idType.length > 0 && this.isIdValid && areValidNames && (this.directory.address.length > 0) && (this.directory.city.length > 0)
      },
      clearNames() {
        this.directory.companyName = "";
        this.directory.name1 = "";
        this.directory.name2 = "";
        this.directory.lastName1 = "";
        this.directory.lastName2 = "";
      },
      idValidator() {
        const foundType = this.idTypes.find(idType => this.directory.idType === idType.id_Tipo_Identificacion)
        
        this.isIdValid = foundType ? foundType.minimo_Digitos_Identificacion <= this.directory.id.length && (foundType.maximo_Digitos_Identificacion >= this.directory.id.length) : false
      },
    },
    computed: {
      selectedDirectory(){
        return this.$store.state.selectedDirectory
      },
      type(){
        return this.selectedDirectory.tipo_Directorio
      },
      isValidForm(){
        const areValidNames = this.enableNameLastname ? this.areValidNames : this.directory.companyName.length > 0
        return this.directory.idType.length > 0 && this.isIdValid && areValidNames && (this.directory.address.length > 0) && (this.directory.city.length > 0)
      },
      areValidNames(){
        return this.directory.name1.length > 0 && (this.directory.lastName1.length > 0)
      },
    }
  }
</script>